module.exports = __webpack_public_path__ + "media/images/mobile/solutions/solutions_lady_mobile-916612ec5e1b0f8839df28f1684f4388.png";